import PropTypes from 'prop-types';
import React from 'react';

import { GoogleAuth } from './GoogleAuth';
import { LazySelect } from '../ReactProtos/CellSelect';

import memoizeOne from 'memoize-one';

let languageSource = null;
/**
 * @returns {Promise<Object<string, Object<string, string>>>}
 */
function getLanguageSource() {
    const id = '1VkhvNsNIxIIgQMVbSvfNhViX3aGqrCNHxddrhBRGjvY';
    const sheets = ['card', 'data', 'ui', 'trigger'];

    if (!languageSource) {
        languageSource = Promise.all(sheets.map(sheet => {
            return GoogleAuth.get().then(() => {
                return window.gapi.client.sheets.spreadsheets.values.get({
                    spreadsheetId: id,
                    range: `${sheet}!A1:K`,
                }).then(response => {
                    const dict = {};
                    const values = response.result.values;
                    const title = values[0];
                    for (let i = 1; i < values.length; i++) {
                        const row = values[i];
                        const entry = (dict[`${sheet}/${row[0]}`] = {});
                        for (let j = 1; j < row.length && j < title.length; j++) {
                            entry[title[j]] = row[j];
                        }
                    }
                    return dict;
                });
            });
        })).then(dicts => {
            console.log(dicts);
            const dict = {};
            for (let one of dicts) {
                for (let key in one) {
                    dict[key] = one[key];
                }
            }
            return dict;
        });
    }
    return languageSource;
}

export class LocalizedInput extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = { languageSource: null };

        this.valueSelectors = memoizeOne((value, label) => ({ value, label }));
    }

    componentDidMount() {
        getLanguageSource().then(result => {
            this.setState({ languageSource: result });
        });
    }

    getOptions() {
        return getLanguageSource().then(result => {
            return Object.keys(result).map(key => ({
                value: key,
                label: key + ': ' + result[key].English,
            }));
        });
    }

    onChange = pair => {
        this.props.onChange(pair.value);
    }

    render() {
        const label = this.state.languageSource && this.state.languageSource[this.props.value] ?
            this.props.value + ': ' + this.state.languageSource[this.props.value].English : (this.props.value || '[None]');
        return <div title={label}>
            <LazySelect readonly={this.props.readonly} value={this.valueSelectors(this.props.value, label)} onChange={this.onChange} getOptions={this.getOptions} />
        </div>;
    }
}

LocalizedInput.propTypes = {
    readonly: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};
